import UpArrowReport from './UpArrowReport';

export default UpArrowReport;